// Демо-форма гранулярных подсказок по адресам.

import utils from "../utils";
import createComponent from "../vue";
import objectLink from "./object-link";
import SuggestionsService from "./service";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

function formatCity(suggestion) {
    const address = suggestion.data;
    if (address.city_with_type === address.region_with_type) {
        return address.settlement_with_type || "";
    }
    return utils.join([address.city_with_type, address.settlement_with_type]);
}

const STATE = {
    address: null,
    flat: "",
    copied: false,
    type: "ADDRESS",
    value: "",
};

const service = new SuggestionsService("ADDRESS");

const properies = {
    postalCode() {
        return (this.address && this.address.postal_code) || "";
    },
};

const methods = {
    initSuggestions(serviceUrl, token) {
        this.initRegion(serviceUrl, token);
        this.initCity(serviceUrl, token);
        this.initStreet(serviceUrl, token);
        this.initHouse(serviceUrl, token);
    },

    initRegion(serviceUrl, token) {
        const $region = $(this.$refs.region);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            hint: false,
            bounds: "region-area",
            onSelect: this.showAddress,
        };
        $region.suggestions(params);
    },

    initCity(serviceUrl, token) {
        const $region = $(this.$refs.region);
        const $city = $(this.$refs.city);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            hint: false,
            bounds: "city-settlement",
            constraints: $region,
            formatSelected: formatCity,
            onSelect: this.showAddress,
        };
        $city.suggestions(params);
    },

    initStreet(serviceUrl, token) {
        const $city = $(this.$refs.city);
        const $street = $(this.$refs.street);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            hint: false,
            bounds: "street",
            constraints: $city,
            onSelect: this.showAddress,
        };
        $street.suggestions(params);
    },

    initHouse(serviceUrl, token) {
        const $street = $(this.$refs.street);
        const $house = $(this.$refs.house);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            hint: false,
            noSuggestionsHint: false,
            bounds: "house",
            constraints: $street,
            onSelect: this.showAddress,
        };
        $house.suggestions(params);
    },

    onFlatChange() {
        const self = this;
        const addressValue = `${this.value}, ${this.flat}`;
        service.enrich(addressValue)
            .done(address => {
                self.address = address;
            });
    },

    onPartChange(part, event) {
        if (!this.address) {
            return;
        }
        const partValue = event.target.value.trim();
        if (partValue.indexOf(this.address[part]) === -1) {
            this.clearAddress();
        }
    },

    showAddress(suggestion) {
        this.value = suggestion.unrestricted_value;
        this.address = suggestion.data;
        service.enrich(suggestion.unrestricted_value, suggestion)
            .done(address => {
                this.address = address;
            });
        Analytics.reachGoal("SUG_DEMO_FORM_ADDRESS");
    },

    clearAddress() {
        this.value = "";
        this.address = null;
        this.flat = "";
    },

    copyLink(event) {
        const url = objectLink.buildUrl("address", this.address.fias_id);
        objectLink.copy(url);
        objectLink.showCopied(this);
        event.preventDefault();
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
        },
        computed: properies,
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const addressConfig = buildConfig(serviceUrl, token);

    createComponent(addressConfig, "#address-granular-vue-app");
}
